import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@presentation/components/Button';

export const NavbarLinkContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  color: ${(props) => props.theme.color.medium.shade};
`;

export const NavbarLinkCategory = styled.div<{ bottomPinned: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  &:not(:first-of-type) {
    ${(props) => !props.bottomPinned && 'padding: 24px 0;'}
  }

  & > *:not(:last-of-type) {
    margin-bottom: 10px;
  }
  ${(props) =>
    props.bottomPinned &&
    `
      margin-top: auto;
      padding: 24px 0;
      border-top: 1px solid ${props.theme.color.light.shadeLighter}};
    `}
  & > *:first-of-type {
    ${(props) => props.bottomPinned && 'margin-top: 10px'}
  }
`;

export const NavbarLinkTitle = styled.div`
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 14px;
  font-family: ${(props) => props.theme.font.default};
  text-align: left;
  font-weight: 600;
  color: ${(props) => props.theme.color.medium.shade};
`;

export const NavbarLink = styled.div<{
  active: boolean;
  highlight: boolean;
  disabled: boolean;
}>`
  padding: 8px 16px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 14px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${(props) => (props.disabled ? props.theme.color.medium.tint : 'inherit')};
  transform: all 300ms ease-in-out;
  position: relative;

  ${(props) =>
    !props.disabled &&
    `
  &:hover::after {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    bottom: 0;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
  `}

  ${(props) =>
    !!props.active &&
    `
    color: ${props.theme.color.light.default};
    background: ${props.theme.color.blue.default};
  `}

  ${(props) =>
    !props.active &&
    props.highlight &&
    `
    color: ${props.theme.color.blue.default};
    background: ${props.theme.color.blue.lightBlue};
  `}

  ${(props) =>
    !!props.active &&
    props.highlight &&
    `
     color: ${props.theme.color.light.default};
    background: ${props.theme.color.blue.default};
  `}
`;

export const NavbarLinkIcon = styled(FontAwesomeIcon)``;

export const NavbarLinkLabel = styled.p`
  display: inline-block;
  margin: 0;
  margin-left: 10px;
`;

export const NotificationDot = styled.span`
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-left: 7px;
  background: ${(props) => props.theme.color.red.default};
`;

export const SideLogoutButtonContainer = styled.div`
  padding: 24px 0;
  border-top: ${(props) => `1px solid ${props.theme.color.light.shadeLighter}`};
`;

export const SideLogoutButton = styled(Button)`
  flex-shrink: 0;
  margin-top: auto;
  width: auto;
  padding: 8px 16px;
  justify-content: flex-start;
`;
